import { useSelector } from "react-redux"
import { selectApproveRejectConflictProposal } from "../../features/conflict-proposal/conflict-proposal-slice"

export const useConflictProposalDataState = () => {

    const approveRejectConflictProposal = useSelector(selectApproveRejectConflictProposal);
    const isShowConfirmationModal = approveRejectConflictProposal.isShowModal === 'actions'
    const isShowViewConflictModal = approveRejectConflictProposal.isShowModal === 'views'
    const conflictProposalId = approveRejectConflictProposal.conflictProposalId
    const actionType = approveRejectConflictProposal.actionType
    const isApproveConflictProposal = actionType === 'approve-conflict'
    const isRejectConflictProposal = actionType === 'reject-conflict'

    return {
        approveRejectConflictProposal,
        isShowConfirmationModal,
        isShowViewConflictModal,
        conflictProposalId,
        actionType,
        isApproveConflictProposal,
        isRejectConflictProposal,
    }
}